import { useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { DateTime } from "luxon";
import AvatarCircle from "app/components/AvatarCircle";
import { LargeCustomIcon, TimelineMarker } from "../../layer00";
import { OneOnOnePrepModal } from "../../layer16";
import { formatTimeUntilMeeting } from "app/containers/TeamsTab/helpers";

export type UpcomingOneOnOneCardProps = {
  personName: string;
  meetingTime: DateTime;
  userAccountId?: number | null;
};

export const UpcomingOneOnOneCard = (props: UpcomingOneOnOneCardProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const meetingTime = props.meetingTime.toLocal();

  return (
    <Box
      className="bg-team-app-gradient-stripe-light border border-teamApp-stripe-mid"
      onClick={() => setIsVisible(true)}
      sx={{
        position: "relative",
        minHeight: "5.5rem",
        borderRadius: "1rem",
        padding: "1rem",
        cursor: "pointer",
      }}
      display="flex"
      flexDirection={{
        xs: "column",
        sm: "row",
      }}
      rowGap="1rem"
      columnGap="1rem"
      alignSelf="stretch"
      alignItems={{
        xs: "flex-start",
        sm: "center",
      }}
    >
      <TimelineMarker />

      <AvatarCircle
        userAccountId={props.userAccountId}
        size="large"
        className="custom-56px"
      />
      <Box
        display={{
          xs: "none",
          sm: "block",
        }}
      >
        <LargeCustomIcon
          icon="SEPERATOR"
          stroke="var(--team-app-divider-subtle)"
          className="w-auto h-[2.5rem]"
        />
      </Box>
      <Stack
        flex={{
          xs: "0 0 auto",
          sm: "1 1 0",
        }}
        width={{
          xs: "100%",
          sm: "auto",
        }}
        minWidth={0}
        direction="column"
        rowGap=".25rem"
        minHeight="1.25rem"
      >
        <Typography variant="cardBodyHeader" className="text-sapphire-150">
          {props.personName}
        </Typography>
        <Typography variant="cardBodyRegular">
          {meetingTime.toFormat("MMM dd")} -{" "}
          {formatTimeUntilMeeting(meetingTime)}
        </Typography>
      </Stack>
      <Box
        alignSelf="stretch"
        minHeight="1.25rem"
        display="flex"
        columnGap=".5rem"
        width={{
          xs: "100%",
          sm: "auto",
        }}
        sx={{ alignItems: "center" }}
      >
        <Button
          sx={{
            padding: ".5rem",
            width: {
              xs: "100%",
              sm: "auto",
            },
            height: "fit-content",
          }}
          variant="outlined"
          color="primary"
          onClick={(e) => {
            e.stopPropagation();
            setIsVisible(true);
          }}
        >
          Prepare
        </Button>
      </Box>
      {isVisible && (
        <OneOnOnePrepModal
          id=""
          isVisible
          handleClose={() => setIsVisible(() => false)}
          userAccountId={props.userAccountId}
          mostRecentCompletedCheckIn
        />
      )}
    </Box>
  );
};
